export const config = {
    appVersion:             'v0.3.2',
    staticExposureData:     '/static/data/static-exposure-data.json',
    usStateData:            '/static/data/us-states.json',
    canadianProvinceData:   '/static/data/canadian-provinces.json',
    formSubmitApi:          '/data/submitContactForm.php',
    facebookAppId:          ''
};


// WEBPACK FOOTER //
// ./src/config.js